import React, { createContext, useState, useEffect } from "react";
import {
    groupProductAndIngredientsByItem,
    computeOutOfStockItems,
} from "../Helpers/util.js";
import { ToastContainer } from "../components/Toast";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useCartContext } from "~/assets/js/global/cartContext";
import { fetchStocks } from "~/assets/js/Api/ingredientsApi";
import useLocationEventListener from "../Helpers/hooks/useLocationEventListener.js";
import cartSession from "../global/cartSession.js";

export const DeliveryContext = createContext({});

const removedProductsFromCartToast = {
    id: Math.random(),
    title: i18next.t("toasts.cartOutOfStock"),
    variant: "warning",
};

// TODO: MOVE THIS TO ../global/*
export const DeliveryProvider = (props) => {
    const [area, setArea] = useState();
    const [location, setLocation] = useState();
    const [address, setAddress] = useState();
    const [storeId, setStoreId] = useState();
    const [loading, setLoading] = useState(true);
    const [toasts, setToasts] = useState([]);
    const { cartItems, actions } = useCartContext();

    const updateAll = (newArea, newAddress, newLocation) => {
        setArea(newArea);
        setAddress(newAddress);
        setLocation(newLocation);
        if (newArea) {
            const groupOrderStore = checkForGroupOrderStore();
            const storeId = groupOrderStore || newArea.store_id;
            setStoreId(storeId);
            updateCartOnStoreChange(storeId);
        }
    };

    useLocationEventListener((evt) => {
        updateAll(evt.detail.area, evt.detail.address, evt.detail.location);
    });

    const checkForGroupOrderStore = () => {
        if (!cartSession.isSet()) {
            return false;
        }

        const cart = cartSession.get();

        if (!cart?.group_cart) {
            return false;
        }

        let cookie = window.cookie.get();

        return cookie?.groupStore || false;
    };

    useEffect(() => {
        let cookie = window.cookie.get();
        updateAll(cookie.area, cookie.address, cookie.location);
        setLoading(false);
    }, []);

    const updateCartOnStoreChange = async (store_id) => {
        if (!store_id) {
            return;
        }

        await actions.updateOnCookieChange();

        if (!cartItems || cartItems?.length <= 0) {
            return;
        }

        // format them to correct data structure
        const { groupedData, iDs } =
            groupProductAndIngredientsByItem(cartItems);

        // check stock for cart items
        const stocks = await fetchStocks(iDs, store_id);
        if (!stocks.ok) {
            return;
        }

        // check if some items from product 'packages' are out of stock
        const outOfStockItems = computeOutOfStockItems(
            groupedData,
            stocks.data
        );

        // No out of stock items, stop here
        if (outOfStockItems.length <= 0) {
            return;
        }

        // removal of all out of stock packages
        const response = await actions.removeMultipleItemsFromCartById(
            outOfStockItems
        );

        if (response.ok) {
            setToasts([removedProductsFromCartToast]);
        }
    };

    const deliveryContext = {
        area,
        setArea,
        location,
        setLocation,
        address,
        setAddress,
        storeId,
        setStoreId,
        updateAll,
        loading,
    };

    return (
        <DeliveryContext.Provider value={deliveryContext}>
            <ToastContainer toasts={toasts} onCancel={() => setToasts([])} />
            {props.children}
        </DeliveryContext.Provider>
    );
};

DeliveryProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export const { DeliveryConsumer } = DeliveryContext;
